import axios from "@/api/axios";

const getVacancies = () => {
  return axios.get(`/vacancy`);
};
export default {
  getVacancies,

};
